(function () {
	'use strict';

    angular.module("imApp").factory("actStatusLangsService", ['$ihttp', function ($ihttp) {
		let service = {
            listLanguages: function (parms) {
                return $ihttp.post({
                    method: 1335,
                    parameters: parms || {}
                });
            },
            saveObj: function (languages) {
                return $ihttp.post({
                    method: 1336,
                    parameters: languages
                });
            }
		};

		return service;
	}]);
})();
